/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Header object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Header = {
	fixed: false,
	init: function () {
		
		$('#avatar-header').dblclick(function () {
			$('#go-profile')[0].click();
		});
		
		var pos = $('#menu').offset().top;
		$(window).scroll(function () {
			var fix = $(window).scrollTop() > pos;
			if (fix && !Header.fixed) {
				Header.fixed = true;
				// FIX
				$('#menu').css('position', 'fixed').css('top', '0');
				//$('main').css('margin-top', '55px');
				
			} else if (!fix && Header.fixed) {
				Header.fixed = false;
				// UNFIX
				$('#menu').css('position', '').css('top', '');
				//$('main').css('margin-top', '');
			}
		});
		
	}
};